import { render, staticRenderFns } from "./CreateFeedback.vue?vue&type=template&id=5cd6cc03&"
import script from "./CreateFeedback.vue?vue&type=script&lang=js&"
export * from "./CreateFeedback.vue?vue&type=script&lang=js&"
import style0 from "./CreateFeedback.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports